import { asyncRoutes, constantRoutes } from '@/router'
import { checkPermissionRule } from '@/utils/permission'

/**
 * Use meta.role to determine if the current user has permission
 * @param {{Array}} permissionCodeList
 * @param route
 */
function hasPermission(permissionCodeList, route) {
  // eslint-disable-next-line no-prototype-builtins
  if (route.meta && route.meta.hasOwnProperty('permissionCode')) {
    return checkPermissionRule(permissionCodeList, route.meta.permissionCode)
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param {{Array}} permissionCodeList
 */
export function filterAsyncRoutes(routes, permissionCodeList) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(permissionCodeList, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, permissionCodeList)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, { roles, permissionCodeList }) {
    return new Promise(resolve => {
      console.log(roles)
      let accessedRoutes
      if (roles.includes('admin')) {
        // 填入超级管理员权限值，我这里自定义超级管理员权限为*，能访问所有路由
        accessedRoutes = asyncRoutes || []
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, permissionCodeList)
      }
      commit('SET_ROUTES', accessedRoutes)
      console.log(accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
